module.exports = __webpack_public_path__ + "img/black_bg.6adf9e16.png";